import { render, staticRenderFns } from "./LogisticaView.vue?vue&type=template&id=6f85733e"
import script from "./LogisticaView.vue?vue&type=script&lang=js"
export * from "./LogisticaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports